module.exports = __webpack_public_path__ + "static/media/kernelcon_hilton4.6128a729.jpg";